import { render, staticRenderFns } from "./CladifyPortal.vue?vue&type=template&id=01a03ae4"
import script from "./CladifyPortal.vue?vue&type=script&lang=js"
export * from "./CladifyPortal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports